// Module
var code = "<div class=\"od-section-time-cell odf-col odf-col-top odf-text-right\"> <div class=\"odf-strong odf-text-md\"> {{ data.time }} </div> <div class=\"odf-text-mono-color-03 odf-text-nowrap odf-text-xs {{ data.textInfoClass }}\"> {{ data.date }} </div> </div>";
// Exports
module.exports = code;